import { jwtDecode } from 'jwt-decode';

// interface JwtPayload {
//   roles?: string[];
//   role?: string;
//   companyRole?: string;
// }

export const getUserRolesFromToken = (
  token: string | null
): string[] => {
  if (!token) return [];

  try {
    const payload = jwtDecode<Record<string, any>>(token);

    const roleClaim =
      payload[
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
      ];

    const rawRoles =
      payload.roles ||
      payload.role ||
      payload.companyRole ||
      roleClaim ||
      [];

    return Array.isArray(rawRoles)
      ? rawRoles
      : [rawRoles];
  } catch {
    return [];
  }
};

export const isAdminUser = (
  token: string | null
): boolean => {
  const roles = getUserRolesFromToken(token);

  return roles.some(
    role => role.toLowerCase() === 'admin'
  );
};

export const getSettingsTabs = (token: string | null) => {
  const isAdmin = isAdminUser(token);
  const tabs = [
    { path: 'profile',label: 'Profile' },
    { path: 'branding', label: 'Branding' },
    { path: 'email', label: 'Email Integration' },
    ...(isAdmin ? [{ path: 'admin', label: 'Admin Settings' }] : []),
    ...(isAdmin ? [{ path: 'diagnostics', label: 'Diagnostics' }] : []),
  ];

  return tabs;
};
